import {
  AnnotationClientDTO,
  POIClientDTO,
  ROIClientDTO,
  RulerClientDTO,
  ScoringWell,
  ScribbleClientDTO,
  WellDetailsStates,
} from 'business/models/CustomModels';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { experiment } from 'components/main/utils';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { setIsRegionImaging } from 'redux/reducers/experimentReducer';
import {
  selectExp,
  selectSelectedOverlay,
} from 'redux/selectors/ExperimentStateSelector';
import {
  selectAnnotations,
  selectAutoSelectNextWell,
  selectCrystals,
  selectIsWellImagingEnabled,
  selectPlateDrawings,
  selectPOIs,
  selectRegionImaging,
  selectROIs,
  selectRulers,
  selectScribbles,
  selectWellDropRegions,
} from 'redux/selectors/StateSelectors';
import {
  DisplayModes,
  GetContainers,
  GetDisplayMode,
  isDropModeUrl,
  GetScoreDefn,
  isDropWellCompare,
  isNullOrUndefined,
  SetDisplayMode,
  downloadFile,
  showAlertSnackBar,
  SetWellsLabels,
  SetCanvasLabels,
  GetDefaultPlatePadding,
  GetPlatePadding,
  GetWellsLabels,
} from 'utils/Global';
import {
  Containers,
  CrystalClientDTO,
  DetailExperimentDTO,
  Plate,
  DropImageParameters,
  WellNavigationDetails,
  ExperimentInfoDto,
  DisplayMode,
  getExperimentCanvasRoutes,
  isScoringFeatureEnabled,
  WIDTH_MAIN_DIV,
  ScoresOfWellDrops,
  ScreenExperimentCanvasRoutes,
} from './constants';
import {
  getDeletedPlates,
  getNewPlate,
  isPlateHaveLayer,
  TreeNode,
} from 'utils/ExperimentUtils';
import {
  dirtifyLayers,
  filterExpLayers,
  setExperiment,
  setExperimentInfo,
  setPlateSize,
  deletePlatesByIds,
  updateExpInfoScreenLots,
  updateExpPlateColDefaultWellVolume,
  updateExpPlateRowDefWellVolume,
  updatePlateDTOandLayers,
  generateWellContents,
  processLayerCreation,
  pruneWellDropsToContainer,
  setWellNavigationDetails,
  selectWellImagingSettingDetails,
  setWellImagingSettingDetails,
  setWellDropsImagingEnabled,
  setPlateImagesStructure,
  setScoringWell,
  appendScoreExperimentWellsInProgressCount,
} from 'redux/reducers/experimentDataReducer';
import { setDeleteLayer } from 'redux/reducers/layerReducer';
import { getExperimentPlateSize } from 'components/main/Experiment';
import { useDispatch, useSelector } from 'react-redux';
import { useModalHandlers } from 'components/modal';
import {
  usePlateImageStructure,
  useLastSelectedWellNavigationDetails,
  useSelectedDropImageParameters,
  useAllPlates,
  useAllDropImageParameters,
  useAllWellNavigationDetails,
  useScoresForWells,
  useAllScoredWells,
} from 'redux/hooks/experiment';
import { ECanvasPreferencesKeys } from 'enums/ECanvasPreferencesKeys';
import {
  useCanvasPreference,
  useFetchExperimentCanvasPreferences,
  useIsZoomLocked,
} from 'redux/hooks/common';
import {
  fetchAllCompositeImagesThunk,
  fetchDrawingIdentifiersThunk,
} from 'redux/thunks/experiment';
import {
  useNavigatorDrops,
  useNavigatorImagingSettings,
  useNavigatorInspections,
  useNavigatorRegions,
  usePlateDisableImageRegions,
} from 'components/commandpanel/Navigator/hooks';
import useBroadcast, {
  CHANNEL_ACTIONS,
  CHANNEL_TYPES,
  MessageType,
} from 'business/broadcast';
import {
  getAvailableCpIds,
  getAvailableInspectionSets,
  GetExperimentCanvasHeight,
  GetExperimentCanvasWidth,
  getSuggestedRotatedScreenName,
  hasImagedWell,
} from './utils';
import { useFocusLevelImages } from 'components/well/hooks';
import { KeyboardKeys } from 'constants/types';
import {
  BooleanPropertyDTO,
  CreateNewTreeNodeDTO,
  EPoiExportType,
  LayerTypeDTO,
  PreferenesDTO,
  RotateScreenDTO,
  TreeNodeDTO,
  NavigatorMapDTO,
  WellSelectionDTO,
  PlateWellDTO,
} from 'business/models/Models';
import WellService from 'business/services/WellService';
import ExperimentService from 'business/services/ExperimentService';
import PlateService from 'business/services/PlateService';
import { GetPlateIngredientsService } from 'business/services/IngredientService';
import { generateScreenStockReportPDF } from 'components/reports/ScreenStockReport';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { Preference } from 'components/main/GlobalPrefrences/constants';
import ScreenService from 'business/services/ScreenService';
import { TreeService } from 'business/services/TreeService';
import useRMLite from 'CustomHooks/useRMLite';
import usePlateGenerated from 'components/customComponents/Renderer/hooks';
import { getWellAndCanvasLabels } from 'components/commandpanel/Navigator/DRCIPWUtil';
import {
  getImagedWellsFromNavigatorMap,
  getWellNavigationDetails,
} from 'components/well/slideShow/utils';
import { TraversalDirection } from 'components/well/slideShow/constants';
import { useWindowSize } from 'CustomHooks/useWindowSize';
import { ExpDashboardContext } from 'components/main/ExperimentDashboardContext';
import { useDebouncedQueue } from 'CustomHooks/useDebouncedQueue';
import { RootState } from 'redux/configureStore';
import { getScoresOfWells } from 'redux/utils/experiment';
import {
  useCurrentDropImage,
  useSetCurrentDropImage,
  useWellDropCompareMode,
} from 'redux/hooks/well';
import {
  NotificationProgressStatus,
  setNotification,
} from 'redux/reducers/notificationReducer';
import { getNavigatorImageKeysAsString } from 'components/commandpanel/Navigator/utils';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';
import { PropertyConstants } from 'enums/PropertyConstants';
import { buildScoringWells, resolveScoringAction } from 'utils/scoringUtils';
import useProductEdition from 'CustomHooks/useProductEdition';

export const maxPlateSize = 35;
const plateService = new PlateService();

export const useExperimentStates = () => {
  const isRegionImaging = useRMSelector(selectRegionImaging);
  const isWellImageEnable = useRMSelector(selectIsWellImagingEnabled);
  const wellDropRegions = useRMSelector(selectWellDropRegions);
  const plateDrawings = useRMSelector(selectPlateDrawings);
  const exp = useRMSelector(selectExp);
  const dispatch = useRMDispatch();
  return {
    isRegionImaging,
    isWellImageEnable,
    wellDropRegions,
    plateDrawings,
    exp,
    dispatch,
  };
};

export const useDropStates = (dropNumber: number) => {
  const annotations: AnnotationClientDTO[] =
    useRMSelector((state) => selectAnnotations(state, dropNumber)) ||
    ([] as AnnotationClientDTO[]);
  const rulers: RulerClientDTO[] =
    useRMSelector((state) => selectRulers(state, dropNumber)) || ([] as RulerClientDTO[]);
  const scribbles: ScribbleClientDTO[] =
    useRMSelector((state) => selectScribbles(state, dropNumber)) ||
    ([] as ScribbleClientDTO[]);
  const rois: ROIClientDTO[] =
    useRMSelector((state) => selectROIs(state, dropNumber)) || ([] as ROIClientDTO[]);
  const pois: POIClientDTO[] =
    useRMSelector((state) => selectPOIs(state, dropNumber)) || ([] as POIClientDTO[]);
  const crystals: CrystalClientDTO[] =
    useRMSelector((state) => selectCrystals(state, dropNumber)) ||
    ([] as CrystalClientDTO[]);
  const selectedOverlay = useRMSelector(selectSelectedOverlay);
  return {
    annotations,
    rulers,
    scribbles,
    rois,
    pois,
    crystals,
    selectedOverlay,
  };
};

export const useTriggerRegionImagingChange = (setRegionImaging) => {
  const { dispatch, isRegionImaging } = useExperimentStates();
  useEffect(() => {
    if (GetDisplayMode() === DisplayModes.IMAGE && isRegionImaging) {
      dispatch(setIsRegionImaging(false));
      setRegionImaging();
    }
  }, [isRegionImaging]);
};

export const useDropLables = () => {
  const exp = useRMSelector(selectExp);
  return exp?.dropLables;
};

export const useExperimentAllImagingSettings = () => {
  return useRMSelector((state) => state?.experiment?.expData?.profiles);
};

export const usePlateRowChangeHandler = () => {
  const { showModal, hideModal } = useModalHandlers();
  const exp = useRMSelector((state) => state.experiment.expData);
  const dispatch = useDispatch();
  return (rowCount): boolean => {
    if (isNullOrUndefined(exp.info)) {
      return false;
    }

    if (exp.info.plateColCount * rowCount > maxPlateSize) {
      showModal({
        body: 'Attempting to resize the canvas produced the following error... The canvas can not have more than 35 plates.',
        heading: 'Error',
        isOkOnly: true,
        okButtonText: 'OK',
        onOk: hideModal,
      });
      return false;
    }

    if (exp.info.plateRowCount > rowCount) {
      const deletedPlateIds: number[] = [];
      let plateHaveLayer = false;
      for (
        let row = rowCount + 1;
        row <= exp.info.plateRowCount && !plateHaveLayer;
        row++
      ) {
        for (let col = 1; col <= exp.colCount && !plateHaveLayer; col++) {
          const index = exp.plateDto.findIndex(
            (plate) => plate.rowPos === row && plate.colPos === col,
          );
          plateHaveLayer = isPlateHaveLayer(exp.plateDto[index], exp.layers);
          const plate = exp.plateDto.find(
            (plate) => plate.rowPos === row && plate.colPos === col,
          );
          deletedPlateIds.push(plate.plateId);
        }
      }
      if (plateHaveLayer) {
        showModal({
          body: 'Attempting to resize the canvas produced the following error... The canvas can not be made smaller than the layers placed on it.',
          heading: 'Error',
          isOkOnly: true,
          okButtonText: 'OK',
          onOk: hideModal,
        });
        return false;
      }
      dispatch(deletePlatesByIds(deletedPlateIds as number[]));
    } else if (exp.info.plateRowCount < rowCount) {
      dispatch(updateExpPlateRowDefWellVolume(rowCount as number));
    }
    dispatch(updatePlateDTOandLayers());
    dispatch(setExperimentInfo({ plateRowCount: rowCount }));
    dispatch(setExperiment({ rowCount: rowCount }));
    const { plateWidth, plateHeight } = getExperimentPlateSize({
      ...exp,
      rowCount: rowCount,
    });
    dispatch(setPlateSize({ plateWidth, plateHeight }));
    return true;
  };
};

export const usePlateColChangeHandler = () => {
  const { showModal, hideModal } = useModalHandlers();
  const exp = useRMSelector((state) => state.experiment.expData);
  const dispatch = useDispatch();
  return (colCount): boolean => {
    if (exp.info.plateRowCount * colCount > maxPlateSize) {
      showModal({
        body: 'Attempting to resize the canvas produced the following error... The canvas can not have more than 35 plates.',
        heading: 'Error',
        isOkOnly: true,
        okButtonText: 'OK',
        onOk: hideModal,
      });
      return false;
    }
    if (isNullOrUndefined(exp.info)) {
      return false;
    }
    if (exp.info.plateColCount > colCount) {
      const deletedPlateIds: number[] = [];
      let plateHaveLayer = false;
      for (let row = 1; row <= exp.info.plateRowCount && !plateHaveLayer; row++) {
        for (
          let col = colCount + 1;
          col <= exp.info.plateColCount && !plateHaveLayer;
          col++
        ) {
          const index = exp.plateDto.findIndex(
            (plate) => plate.rowPos === row && plate.colPos === col,
          );
          plateHaveLayer = isPlateHaveLayer(exp.plateDto[index], exp.layers);
          const plate = exp.plateDto.find(
            (plate) => plate.rowPos === row && plate.colPos === col,
          );
          deletedPlateIds.push(plate.plateId);
        }
      }
      if (plateHaveLayer) {
        showModal({
          body: 'Attempting to resize the canvas produced the following error... The canvas can not be made smaller than the layers placed on it.',
          heading: 'Error',
          isOkOnly: true,
          okButtonText: 'OK',
          onOk: hideModal,
        });
        return false;
      }
      dispatch(deletePlatesByIds(deletedPlateIds as number[]));
    } else if (exp.info.plateColCount < colCount) {
      dispatch(updateExpPlateColDefaultWellVolume(colCount as number));
    }
    dispatch(setExperimentInfo({ plateColCount: colCount }));
    dispatch(setExperiment({ colCount: colCount }));
    dispatch(updatePlateDTOandLayers());
    const { plateWidth, plateHeight } = getExperimentPlateSize({
      ...exp,
      colCount: colCount,
    });
    dispatch(setPlateSize({ plateWidth, plateHeight }));
    return true;
  };
};

export const usePlateTypeChangeHandler = () => {
  const { showModal, hideModal } = useModalHandlers();
  const exp = useRMSelector((state) => state.experiment.expData);
  const dispatch = useDispatch();
  return (value, updateExpInfo, setPlateType) => {
    const prevPlateDetails = {
      cols: exp.containerCols,
      rows: exp.containerRows,
      colCount: exp.colCount,
      rowCount: exp.rowCount,
    };
    const containers = GetContainers() as Containers[];
    const selectedContainer = containers.find((c) => c.id === value);

    if (exp.info.hasLayers || exp.layers.length > 0) {
      const plateRows = Math.ceil(
        (prevPlateDetails.rows * prevPlateDetails.rowCount) / selectedContainer.rows,
      );
      const plateCols = Math.ceil(
        (prevPlateDetails.cols * prevPlateDetails.colCount) / selectedContainer.cols,
      );
      if (plateRows * plateCols > maxPlateSize) {
        showModal({
          body: 'Attempting to resize the canvas produced the following error... The canvas can not have more than 35 plates.',
          heading: 'Error',
          isOkOnly: true,
          okButtonText: 'OK',
          onOk: hideModal,
        });
        return;
      } else if (
        exp.layers.find((lyr) => lyr.targetDrop > selectedContainer.containerDrops.length)
      ) {
        const removedLayers = exp.layers.filter(
          (lyr) => lyr.targetDrop > selectedContainer.containerDrops.length,
        );
        const layers = exp.layers.filter(
          (lyr) => lyr.targetDrop <= selectedContainer.containerDrops.length,
        );
        dispatch(filterExpLayers(layers));
        // mark the removed layers as deleted so the backend removes them on save
        removedLayers.forEach((lyr) => dispatch(setDeleteLayer(lyr)));
        showModal({
          body: 'The new container does not contain a sufficient number of sub-wells; some data will be lost.',
          heading: 'Warning',
          isOkOnly: true,
          okButtonText: 'OK',
          onOk: hideModal,
        });
      }
    }
    setPlateType(selectedContainer.id.toString());
    updateExpInfo.containerId = selectedContainer.id;
    const expDataDto = {
      containerCols: selectedContainer.cols,
      containerRows: selectedContainer.rows,
      containerDrops: selectedContainer.containerDrops,
      containerMaxDropVolume: selectedContainer.maxDropVolume,
      containerMaxWellVolume: selectedContainer.maxWellVolume,
      containerDefSeedVolume: selectedContainer.defaultSeedVolume,
      containerDefaultFragmentVolume: selectedContainer.defaultFragmentVolume,
    } as DetailExperimentDTO;
    dispatch(
      setExperimentInfo({
        plateType: selectedContainer.name,
        containerId: selectedContainer.id,
      }),
    );
    dispatch(setExperiment(expDataDto));

    const wellCount = selectedContainer.rows * selectedContainer.cols;
    const plates: Plate[] = [];
    let plateNumber = 1;
    let plateRows = exp.info.plateRowCount,
      plateCols = exp.info.plateColCount;

    if (exp.info.hasLayers || exp.layers.length > 0) {
      plateRows = Math.ceil(
        (prevPlateDetails.rows * prevPlateDetails.rowCount) / selectedContainer.rows,
      );
      plateCols = Math.ceil(
        (prevPlateDetails.cols * prevPlateDetails.colCount) / selectedContainer.cols,
      );
    }

    for (let row = 1; row <= plateRows; row++) {
      for (let col = 1; col <= plateCols; col++) {
        const newPlate = getNewPlate(plateNumber, selectedContainer, row, col, wellCount);
        plates.push(newPlate);
        plateNumber++;
      }
    }
    const deletedPlateIds = getDeletedPlates(exp.plateDto, plates);
    const expDataDTO = {
      colCount: plateCols,
      rowCount: plateRows,
      deletedPlateIds: [...exp.deletedPlateIds, ...deletedPlateIds],
      plateDto: plates,
      defWellVolume: selectedContainer.defaultWellVolume,
      isDirty: true,
    } as DetailExperimentDTO;
    dispatch(setExperimentInfo({ plateColCount: plateCols, plateRowCount: plateRows }));
    dispatch(setExperiment(expDataDTO));

    dispatch(generateWellContents(false));
    dispatch(dirtifyLayers());

    const { plateWidth, plateHeight } = getExperimentPlateSize({
      ...exp,
      colCount: plateCols,
      rowCount: plateRows,
      containerCols: selectedContainer.cols,
      containerRows: selectedContainer.rows,
    });
    dispatch(setPlateSize({ plateWidth, plateHeight }));
    dispatch(updateExpInfoScreenLots(selectedContainer.id));
    dispatch(processLayerCreation());

    // prune drops that are not in new container's range
    if (selectedContainer.containerDrops?.length) {
      dispatch(pruneWellDropsToContainer(selectedContainer.containerDrops));
    }

    // by changing plate type, the canvas labels and well labels need to be reset
    const { wellLabels, canvasLabels } = getWellAndCanvasLabels(
      selectedContainer.cols,
      selectedContainer.rows,
    );
    SetWellsLabels(wellLabels);
    SetCanvasLabels(canvasLabels);
  };
};

export const usePlateImagingState = (): boolean => {
  const { exp } = useExperimentStates();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const imagingTasksEnabled = wellNavigationDetails
    ? exp?.plateDto?.find((p) => p.plateId === wellNavigationDetails.plateID)
        ?.imagingTasksEnabled ?? false
    : exp?.plateDto?.find((p) => p.imagingTasksEnabled)?.imagingTasksEnabled ?? false;
  return imagingTasksEnabled;
};

export const useExperimentImagingDisabledState = (): boolean => {
  const { exp } = useExperimentStates();
  return exp?.plateDto?.every((p) => p.imagingTasksEnabled === false);
};

export const useIsWellImagingEnabled = (dropNumber: number): boolean => {
  const getPlateDisabledImageRegions = usePlateDisableImageRegions();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const disabledImageRegions = getPlateDisabledImageRegions(
    wellNavigationDetails?.plateID,
  );
  const isWellImagingEnabled = useRMSelector((state) =>
    selectIsWellImagingEnabled(state),
  );
  const wellImagingState = useMemo(() => {
    const disabledImageRegion = disabledImageRegions?.find(
      (p) =>
        p.wellNumber === wellNavigationDetails.wellNum && p.dropNumber === dropNumber,
    );
    return disabledImageRegion?.imagingEnabled;
  }, [disabledImageRegions, wellNavigationDetails, dropNumber]);
  return wellImagingState ?? isWellImagingEnabled;
};

export const useSetExperimentCanvasPreferences = () => {
  const fetchCanvasPreferences = useFetchExperimentCanvasPreferences();
  const properties = [
    ECanvasPreferencesKeys.POIColor,
    ECanvasPreferencesKeys.DeleteScore,
    ECanvasPreferencesKeys.NameProteinLayerUsingPFName,
    ECanvasPreferencesKeys.RotateCanvasMessageBox,
    ECanvasPreferencesKeys.AutoMoveAfterScoring,
    ECanvasPreferencesKeys.SelectedCanvasScoreGroups,
    ECanvasPreferencesKeys.SelectedWellColor,
    ECanvasPreferencesKeys.SelectedLayerColor,
    ECanvasPreferencesKeys.RestartWellNavigationOnceEnd,
    ECanvasPreferencesKeys.ScoreWithoutImages,
  ];
  useEffect(() => {
    fetchCanvasPreferences(properties);
  }, []);
};
export const useFetchDrawingIdentifiers = () => {
  const dispatch = useRMDispatch();
  return (plates: Plate[], wellDetails: WellDetailsStates) => {
    dispatch(fetchDrawingIdentifiersThunk({ plates: plates, wellDetails: wellDetails }));
  };
};

export const useUpdateCompositeImagesHandler = () => {
  const dispatch = useRMDispatch();
  const plateImagesStructure = usePlateImageStructure();
  return async (
    wellNavigationDetails: WellNavigationDetails,
    wellImagingSettingDetails: DropImageParameters,
    regenerate: boolean = false,
  ) => {
    dispatch(
      setNotification({
        message: 'Generating Images...',
        progressStatus: NotificationProgressStatus.InProgress,
        progress: 0,
      }),
    );
    dispatch(
      fetchAllCompositeImagesThunk({
        plates: plateImagesStructure,
        wellNavigationDetails,
        wellImagingSettingDetails,
        regenerate,
      }),
    );
  };
};

export const useExperimentBroadCastReceiver = (
  treeNodeId: number,
  setBreadCrumbs: React.Dispatch<React.SetStateAction<TreeNodeDTO[]>>,
  setExpHeaderName: React.Dispatch<React.SetStateAction<string>>,
  expInfo: ExperimentInfoDto,
) => {
  const explorerBroadcastChannel = useBroadcast(CHANNEL_TYPES.EXPLORER);
  const dispatch = useRMDispatch();

  useEffect(() => {
    const handleBroadcastMessageReceive = (
      messageEvent: MessageEvent<MessageType<TreeNodeDTO>>,
    ) => {
      const { action, payload: node } = messageEvent.data;

      if (action === CHANNEL_ACTIONS.EXPLORER_RENAME_NODE && node?.id === treeNodeId) {
        setBreadCrumbs((prev) => {
          const updated = [...prev];
          updated[0] = TreeNodeDTO.fromJS({ ...updated[0], name: node.name });
          return updated;
        });
        setExpHeaderName(node.name);

        if (expInfo) {
          dispatch(setExperimentInfo({ name: node.name }));
        }
      }
    };

    if (explorerBroadcastChannel) {
      explorerBroadcastChannel.onmessage = handleBroadcastMessageReceive;
    }

    return () => {
      if (explorerBroadcastChannel) {
        explorerBroadcastChannel.onmessage = null;
      }
    };
  }, [
    explorerBroadcastChannel,
    treeNodeId,
    setBreadCrumbs,
    setExpHeaderName,
    dispatch,
    expInfo,
  ]);
};

const useInspectionNavigationHandler = (navigatorMap: NavigatorMapDTO) => {
  const dispatch = useDispatch();
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();

  const { cpId, dropNumber, inspection, regionName } = selectedDropImageParameters;
  const { plateID } = wellNavigationDetails || {};

  const availableInspections = useMemo(
    () => getAvailableInspectionSets(navigatorMap, plateID, cpId, dropNumber, regionName),
    [navigatorMap, plateID, cpId, dropNumber, regionName],
  );

  const changeInspection = (direction: 'next' | 'previous') => {
    if (!inspection || !availableInspections?.length) {
      return;
    }

    const currentInspectionSetIndex = availableInspections?.findIndex(
      (insp) => insp.id === inspection.id,
    );
    if (currentInspectionSetIndex === -1) {
      return;
    }
    const newIndex =
      direction === 'next'
        ? (currentInspectionSetIndex + 1) % availableInspections.length
        : (currentInspectionSetIndex - 1 + availableInspections.length) %
          availableInspections.length;

    const newInspectionSet = availableInspections?.[newIndex];
    if (!newInspectionSet) {
      return;
    }
    if (newInspectionSet) {
      const wellInfo = {
        ...selectedDropImageParameters,
        inspection: newInspectionSet,
      };

      dispatch(setWellImagingSettingDetails([wellInfo]));
      updateCompositeImages(wellNavigationDetails, wellInfo);
    }
  };

  return { changeInspection };
};

const useDropNavigationHandler = () => {
  const dispatch = useDispatch();
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const dropLables = useDropLables();

  const changeDrop = (direction: 'next' | 'previous') => {
    const currentDropIndex = dropLables.findIndex(
      (drop) => drop.id === selectedDropImageParameters?.dropNumber,
    );
    const newIndex =
      direction === 'next'
        ? (currentDropIndex + 1) % dropLables.length
        : (currentDropIndex - 1 + dropLables.length) % dropLables.length;

    const wellInfo: DropImageParameters = {
      ...selectedDropImageParameters,
      dropNumber: dropLables[newIndex].id,
    };

    dispatch(setWellImagingSettingDetails([wellInfo]));
    updateCompositeImages(wellNavigationDetails, wellInfo);
  };

  return { changeDrop };
};

const useImagingSettingsNavigationHandler = (navigatorMap: NavigatorMapDTO) => {
  const dispatch = useDispatch();
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { dropNumber, regionName, cpId, inspection } = selectedDropImageParameters;

  const imageBatchId = useMemo(
    () =>
      inspection?.groupedInspections?.find(
        (gi) => gi.plateId === wellNavigationDetails.plateID,
      )?.imageBatchId,
    [inspection, wellNavigationDetails],
  );

  const availableCPids = useMemo(
    () => getAvailableCpIds(navigatorMap, dropNumber, imageBatchId, regionName),
    [navigatorMap, dropNumber, imageBatchId, regionName],
  );

  const changeImagingSettings = (direction: 'next' | 'previous') => {
    if (!cpId) {
      return;
    }

    const currentImagingSettingsIndex = availableCPids.findIndex(
      (availableCpId) => availableCpId === cpId,
    );

    if (currentImagingSettingsIndex === -1) {
      return;
    }

    const newIndex =
      direction === 'next'
        ? (currentImagingSettingsIndex + 1) % availableCPids.length
        : (currentImagingSettingsIndex - 1 + availableCPids.length) %
          availableCPids.length;

    const wellInfo: DropImageParameters = {
      ...selectedDropImageParameters,
      cpId: availableCPids[newIndex],
    };

    dispatch(setWellImagingSettingDetails([wellInfo]));
    updateCompositeImages(wellNavigationDetails, wellInfo);
  };

  return { changeImagingSettings };
};

const useRegionNavigationHandler = () => {
  const dispatch = useDispatch();
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { exp } = useExperimentStates();

  const changeRegions = (direction: 'next' | 'previous') => {
    const regions = exp.regions;
    const currentRegionIndex = regions.findIndex(
      (region) => region.name === selectedDropImageParameters.regionName,
    );
    const newIndex =
      direction === 'next'
        ? (currentRegionIndex + 1) % regions.length
        : (currentRegionIndex - 1 + regions.length) % regions.length;
    const wellInfo: DropImageParameters = {
      ...selectedDropImageParameters,
      regionName: regions[newIndex].name,
    };
    dispatch(setWellImagingSettingDetails([wellInfo]));

    updateCompositeImages(wellNavigationDetails, wellInfo);
  };

  return { changeRegions };
};

const usePlateNavigationHandler = () => {
  const dispatch = useDispatch();
  const allPlates = useAllPlates();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();

  const changePlate = (direction: 'next' | 'previous') => {
    const currentPlateIndex = allPlates.findIndex(
      (plate) => plate.plateId === wellNavigationDetails?.plateID,
    );
    const newIndex =
      direction === 'next'
        ? (currentPlateIndex + 1) % allPlates.length
        : (currentPlateIndex - 1 + allPlates.length) % allPlates.length;

    dispatch(
      setWellNavigationDetails([
        {
          ...wellNavigationDetails,
          plateNum: allPlates[newIndex].plateNumber,
          plateID: allPlates[newIndex].plateId,
        },
      ]),
    );
  };

  return { changePlate };
};

const useFocusLevelNavigationHandler = () => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const focusLevelImages = useFocusLevelImages(
    wellNavigationDetails,
    selectedDropImageParameters,
  );

  const dropImage = useCurrentDropImage();
  const setCurrentDropImage = useSetCurrentDropImage();

  const changeFocusLevel = useCallback(
    (direction: 'next' | 'previous') => {
      const currentFocusLevelIndex = Math.max(
        focusLevelImages.findIndex((fl) => fl.imageTitle === dropImage?.imageTitle),
        0,
      );
      const newIndex =
        direction === 'next'
          ? (currentFocusLevelIndex + 1) % focusLevelImages.length
          : (currentFocusLevelIndex - 1 + focusLevelImages.length) %
            focusLevelImages.length;
      const focusLevelImage = focusLevelImages[newIndex];
      if (!focusLevelImage) {
        return;
      }
      setCurrentDropImage({
        ...focusLevelImage,
        image: focusLevelImage.image,
        pixelSize: focusLevelImage.pixelSize || undefined,
        imageTitle: focusLevelImage.imageTitle || '',
      });
    },
    [focusLevelImages, dropImage, setCurrentDropImage],
  );

  return { changeFocusLevel };
};

export const useExportPOI = () => {
  return async (
    expId,
    plateId,
    wellNum,
    dropNumber,
    regionId,
    isDropModeUrl,
    exportType: EPoiExportType = EPoiExportType.Default,
    plateIds?: number[] | null,
  ) => {
    const wellService = new WellService();
    const fileResponse = plateIds?.length
      ? await wellService.generatePoiCsvFile(
          expId,
          isDropModeUrl,
          plateId,
          wellNum,
          dropNumber,
          regionId,
          exportType,
          plateIds,
        )
      : await wellService.generatePoiCsvFile(
          expId,
          isDropModeUrl,
          plateId,
          wellNum,
          dropNumber,
          regionId,
          exportType,
        );
    await downloadFile(fileResponse.data, fileResponse.fileName);
  };
};

export const useMarkAsNotSeen = () => {
  return async (selectedNodes, setTreeControlState) => {
    const expIds = selectedNodes.map((node) => node?.extra?.id);
    await new ExperimentService().markExperimentAsNotSeen(expIds);
    const updatedNodes = selectedNodes.map((node) => (node.extra.notSeen = true));
    setTreeControlState((prev) => ({ ...prev, selectedNodes: [updatedNodes] }));
  };
};

export const useGenerateScreenStocksReport = () => {
  return async (expId) => {
    const screen = await new PlateService().getScreenByExpId(expId);
    const plates: any[] = [];
    for (const plt of screen.plateDto) {
      plates.push(await GetPlateIngredientsService(plt.plateId));
    }

    await generateScreenStockReportPDF(expId, screen, plates, false);
  };
};

export const useRotateCanvas = () => {
  const { showLoadingModal, showAwaitableModal, hideModal } = useModalHandlers();

  const clearProperties = async (updatedProperties) => {
    updatedProperties = [];
    hideModal();
  };

  const PerformRotation = async (
    selectedNodes,
    updatedProperties,
    createNewNode,
    getNewScreenName,
  ) => {
    showLoadingModal('Rotating Screen');
    const rotateScreenList: RotateScreenDTO[] = selectedNodes.map((node) => {
      return {
        treeNodeId: node.id,
        treeNodeParentId: node.parentId,
      } as RotateScreenDTO;
    });

    if (updatedProperties?.length) {
      const preferences = new PreferenesDTO();
      preferences.baseProperties = updatedProperties;
      preferences.preferenceType = Preference.UserPreference;
      const gpService = new GlobalPreferencesService();
      await gpService.setAllProperties(preferences);
      updatedProperties = [];
    }

    const treeNodeDTOList: CreateNewTreeNodeDTO[] =
      await new ScreenService().rotateScreen(rotateScreenList);
    let rotatedScreenName =
      selectedNodes.length === 1 ? getNewScreenName?.()?.trim() : undefined;
    const suggestedRotatedScreenName =
      selectedNodes.length === 1
        ? getSuggestedRotatedScreenName(selectedNodes[0].name)
        : undefined;
    const backendGeneratedDifferentName =
      rotatedScreenName &&
      suggestedRotatedScreenName === rotatedScreenName &&
      treeNodeDTOList[0]?.name !== suggestedRotatedScreenName;

    if (backendGeneratedDifferentName) {
      rotatedScreenName = treeNodeDTOList[0].name;
    } else if (treeNodeDTOList[0]?.id && rotatedScreenName) {
      await new TreeService().renameNode(treeNodeDTOList[0].id, rotatedScreenName);
      treeNodeDTOList[0].name = rotatedScreenName;
    }

    for (const treeNodeDTO of treeNodeDTOList.filter(Boolean)) {
      const screenUrl = `/screen/${treeNodeDTO.expId}`;
      const rotatedScreenUrl = rotatedScreenName
        ? `${screenUrl}?rotatedName=${encodeURIComponent(rotatedScreenName)}`
        : screenUrl;

      window.open(rotatedScreenUrl, screenUrl);
      createNewNode(treeNodeDTO, [], treeNodeDTO.parentId);
    }

    hideModal();
  };

  return async (
    selectedNodes,
    rotateCanvasModalBody,
    updatedProperties,
    createNewNode,
    getNewScreenName,
  ) => {
    const selectedScreensIds: number[] = selectedNodes.map((node) => {
      return node.extra.id;
    });

    const selectedScreensLayers = await new ExperimentService().getExpListLayers(
      selectedScreensIds,
    );

    for (const screen of selectedScreensLayers) {
      const customLayer = screen.layers?.filter(
        (layer: any) =>
          layer.type === LayerTypeDTO.ConditionList &&
          layer.layerDetail?.condition.length === 96,
      ) as any;
      const maxConditions = (customLayer[0]?.height + 1) * (customLayer[0]?.width + 1);
      if (
        maxConditions < 96 ||
        screen.layers?.length > 1 ||
        !customLayer?.length ||
        customLayer.length > 1
      ) {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'There must be 96 conditions present in only one custom layer to perform this action',
        );
        return;
      }
    }

    if (selectedNodes.length > 1) {
      await PerformRotation(
        selectedNodes,
        updatedProperties,
        createNewNode,
        getNewScreenName,
      );
      return;
    }

    const gpService = new GlobalPreferencesService();
    const screenRotateCanvasShowMessageBox = await gpService.getProperty(
      'Screen.RotateCanvas.ShowMessageBox',
    );
    const showRotateCanvasMessageBoxPropValue = (
      screenRotateCanvasShowMessageBox as BooleanPropertyDTO
    ).value;

    const hasNameLengthWarning = selectedNodes.some(
      (node) =>
        node.name.endsWith(experiment.RotateExpName) ||
        `${node.name}${experiment.RotateExpName}`.length > TreeNode.TreeNodeNameMaxLength,
    );

    if (showRotateCanvasMessageBoxPropValue || hasNameLengthWarning) {
      await showAwaitableModal({
        body: rotateCanvasModalBody,
        onOk: () =>
          PerformRotation(
            selectedNodes,
            updatedProperties,
            createNewNode,
            getNewScreenName,
          ),
        onHide: () => clearProperties(updatedProperties),
        heading: 'Rotate Canvas',
      });
    } else {
      PerformRotation(selectedNodes, updatedProperties, createNewNode, getNewScreenName);
    }
  };
};

export const useSetDropImageParameters = (navigatorMap: NavigatorMapDTO) => {
  const allDropImageParameters = useAllDropImageParameters();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const compositeKey = getNavigatorImageKeysAsString(
    wellNavigationDetails,
    allDropImageParameters[allDropImageParameters?.length - 1],
  );
  const availableImagingSettings = useNavigatorImagingSettings(compositeKey);
  const availableInspections = useNavigatorInspections(compositeKey);
  const availableDrops = useNavigatorDrops(compositeKey);
  const availableRegions = useNavigatorRegions(compositeKey);
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { isCompareModeOverlay } = useWellDropCompareMode();

  // Map of available values for each parameter type (cpId, inspection, dropNumber, regionName)
  const availableImagesMap = useMemo(() => {
    return {
      cpId: availableImagingSettings?.map((imagingSetting) => imagingSetting.cpId) || [],
      inspection: availableInspections?.map((inspection) => inspection.batchId) || [],
      dropNumber: availableDrops?.map((drop) => drop.dropNumber) || [],
      regionName: availableRegions?.map((region) => region.imageName) || [],
    };
  }, [availableImagingSettings, availableInspections, availableDrops, availableRegions]);

  const dispatch = useRMDispatch();

  return (
    wellInfo: DropImageParameters,
    updatedParameter: keyof DropImageParameters,
    direction?: 'next' | 'previous',
  ) => {
    // Case 1: Single or no items in comparison list
    // Reset to only the new wellInfo when starting fresh or comparing single item
    if (allDropImageParameters?.length <= 1) {
      dispatch(setWellImagingSettingDetails([wellInfo]));
      return;
    }

    // Find the parameter key that differs between comparison items (e.g., 'dropNumber', 'cpId')
    const compareBy = Object.keys(allDropImageParameters[1]).find(
      (key) => allDropImageParameters[0][key] !== allDropImageParameters[1][key],
    ) as keyof DropImageParameters | undefined;

    // Case 2: Updated parameter doesn't match the comparison dimension
    // User changed a different parameter, so reset comparison to only the new wellInfo
    if (!compareBy || compareBy !== updatedParameter) {
      const newWellInfos = allDropImageParameters
        .map((obj) => ({ ...obj, [updatedParameter]: wellInfo[updatedParameter] }))
        .filter((wellInfo) => {
          const imageBatchId = wellInfo.inspection?.groupedInspections?.find(
            (insp) => insp.plateId === wellNavigationDetails.plateID,
          )?.imageBatchId;
          const matchingDrcis =
            navigatorMap?.drciList?.filter(
              (drci) =>
                drci.drc.cpId === wellInfo.cpId &&
                drci.drc.dropNumber === wellInfo.dropNumber &&
                drci.drc.regionName === wellInfo.regionName,
            ) ?? [];
          return matchingDrcis.some((drci) =>
            drci.inspectedWells.some(
              (insp) =>
                insp.inspectionId === imageBatchId &&
                insp.wells.some(
                  (well) =>
                    well.plateId === wellNavigationDetails.plateID &&
                    well.wellNumber === wellNavigationDetails.wellNum,
                ),
            ),
          );
        });
      if (newWellInfos.length > 0) {
        dispatch(setWellImagingSettingDetails(newWellInfos));
      } else {
        dispatch(setWellImagingSettingDetails([wellInfo]));
      }
      return;
    }

    // Case 3: Updated parameter matches the comparison dimension
    // Check if the new value exists in available options
    const availableValues = availableImagesMap[compareBy];
    const isImageSettingAvailable =
      availableValues?.some((value) => {
        if (compareBy === 'inspection') {
          return (
            value ===
            wellInfo.inspection.groupedInspections.find(
              (insp) => insp.plateId === wellNavigationDetails.plateID,
            )?.imageBatchId
          );
        }
        return value === wellInfo[compareBy];
      }) ?? false;
    const isAlreadyInList = allDropImageParameters.some(
      (dropImageParameter) => dropImageParameter[compareBy] === wellInfo[compareBy],
    );

    // Add to comparison list if it's a new available value
    if (!isAlreadyInList && isImageSettingAvailable) {
      let updatedList: DropImageParameters[];

      if (isCompareModeOverlay) {
        updatedList = [wellInfo];
      } else {
        updatedList =
          allDropImageParameters.length < 4
            ? [wellInfo, ...allDropImageParameters]
            : [wellInfo, ...allDropImageParameters.slice(1)];
      }

      dispatch(setWellImagingSettingDetails(updatedList));
    }

    // Handle selection based on availability
    if (isImageSettingAvailable) {
      // Case 3a: Value is available - select it
      dispatch(selectWellImagingSettingDetails(wellInfo));
    } else {
      // Case 3b: Value is not available - navigate to next/previous or fallback to wellInfo
      if (direction) {
        // Navigate to next or previous item in the comparison list
        const currentIndex = allDropImageParameters.findIndex(
          (params) => params[compareBy] === selectedDropImageParameters[compareBy],
        );
        const newIndex =
          direction === 'next'
            ? (currentIndex + 1) % allDropImageParameters.length
            : (currentIndex - 1 + allDropImageParameters.length) %
              allDropImageParameters.length;
        dispatch(selectWellImagingSettingDetails(allDropImageParameters[newIndex]));
      } else {
        // No direction provided - select wellInfo anyway (fallback)
        dispatch(selectWellImagingSettingDetails(wellInfo));
      }
    }
  };
};

export const useInspectionChange = (inspections, navigatorMap?: NavigatorMapDTO) => {
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const setDropImageParameters = useSetDropImageParameters(navigatorMap);
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  return async (value, direction?: 'next' | 'previous') => {
    const inspectionSetIndex = parseInt(value, 10);
    const selectedInspectionSet = inspections.find(
      (inspSet) => inspSet.id == inspectionSetIndex,
    );
    const wellInfo: DropImageParameters = {
      ...selectedDropImageParameters,
      inspection: selectedInspectionSet,
    };
    setDropImageParameters(wellInfo, 'inspection', direction);
    updateCompositeImages(wellNavigationDetails, wellInfo);
  };
};

export const useToggleWellDropImage = () => {
  const wellNavigationDetails = useAllWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const isWellImagingEnabled = useIsWellImagingEnabled(
    selectedDropImageParameters?.dropNumber,
  );
  const dispatch = useRMDispatch();
  return useCallback(async () => {
    const wells = wellNavigationDetails?.map((w) => ({
      plateId: w.plateID,
      wellNumber: w.wellNum,
      dropNumber: selectedDropImageParameters?.dropNumber,
    })) as WellSelectionDTO[];
    dispatch(
      setWellDropsImagingEnabled({
        wellDropRegions: wells,
        imagingEnabled: !isWellImagingEnabled,
      }),
    );
    await new WellService().setWellDropImagingEnabled(wells, !isWellImagingEnabled);
  }, [selectedDropImageParameters, wellNavigationDetails, isWellImagingEnabled]);
};

export const useMarkInterestingWellDrop = () => {
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { inspection } = selectedDropImageParameters || {};
  const allWellNavigationDetails = useAllWellNavigationDetails();
  const isDropWellCompareMode = isDropWellCompare();

  const selectedWellDetails = isDropWellCompareMode
    ? [allWellNavigationDetails[allWellNavigationDetails.length - 1]]
    : allWellNavigationDetails;
  const imageBatchId = inspection?.groupedInspections?.find(
    (grp) => grp.plateId === selectedWellDetails?.[0]?.plateID,
  )?.imageBatchId;

  const applyScoring = useApplyScoring();
  return useCallback(
    (key: string, isActiveScore: boolean, forceRemoveInteresting?: boolean) => {
      if (!imageBatchId) {
        return;
      }
      const score = GetScoreDefn().find((s) => s.hotKey === key);
      applyScoring(
        score.wellDropScoreId,
        score.wellDropScoreGroupId,
        forceRemoveInteresting,
      );
    },
    [imageBatchId, applyScoring, inspection, allWellNavigationDetails],
  );
};

export const useApplyScoring = () => {
  const autoSelectNextWell = useRMSelector(selectAutoSelectNextWell);
  const allWellNavigationDetails = useAllWellNavigationDetails();
  const isScoringWithoutImagesAllowed = useCanvasPreference(
    ECanvasPreferencesKeys.ScoreWithoutImages,
  );
  const isDropWellCompareMode = isDropWellCompare();
  const selectedWellDetails = isDropWellCompareMode
    ? [allWellNavigationDetails[allWellNavigationDetails.length - 1]]
    : allWellNavigationDetails;
  const exp = useRMSelector(selectExp);
  const expDashboardContext = useContext(ExpDashboardContext);
  const scoreExperimentWells = useScoreExperimentWells();
  const canScore = useMemo(
    () =>
      isScoringWithoutImagesAllowed ||
      hasImagedWell(selectedWellDetails, expDashboardContext.imagedWells),
    [
      isScoringWithoutImagesAllowed,
      allWellNavigationDetails,
      expDashboardContext.imagedWells,
    ],
  );

  const showEndOfExperimentMessage = (
    wellDetails: WellNavigationDetails,
    imagedWells: PlateWellDTO[],
    backIndex: number = 2,
  ) => {
    if (
      imagedWells?.length &&
      wellDetails?.plateID === imagedWells[imagedWells.length - backIndex]?.plateId &&
      wellDetails?.wellNum === imagedWells[imagedWells.length - backIndex]?.wellNumber
    ) {
      showAlertSnackBar(
        EAlertType.INFO,
        ESnackBarPosition.TOP,
        "You've reached the end of the current Experiment.",
      );
    }
  };

  const getAutoSelectNextWellNumToScore = () => {
    if (autoSelectNextWell && !isScoringWithoutImagesAllowed) {
      const nextWellDetails = getWellNavigationDetails(
        exp?.plateDto,
        selectedWellDetails[0],
        1,
        TraversalDirection.Row,
        expDashboardContext.imagedWells,
      );
      return nextWellDetails;
    }
    return null;
  };

  return useCallback(
    (
      wellDropScoreId: number,
      wellDropScoreGroupId: number,
      forceRemoveInteresting?: boolean,
    ) => {
      if (!canScore) {
        return;
      }
      const isSingleWellSelected = selectedWellDetails.length === 1;
      scoreExperimentWells({
        wellDropScoreId,
        wellDropScoreGroupId,
        autoSelectNextWell: autoSelectNextWell && isSingleWellSelected,
        nextWellDetails: isSingleWellSelected ? getAutoSelectNextWellNumToScore() : null,
        forceRemoveInteresting,
      });
      if (autoSelectNextWell && isSingleWellSelected) {
        showEndOfExperimentMessage(
          selectedWellDetails[0],
          expDashboardContext.imagedWells,
        );
      }
    },
    [autoSelectNextWell, allWellNavigationDetails, scoreExperimentWells, canScore],
  );
};

export const useMarkInteresting = () => {
  const isDropWellCompareMode = isDropWellCompare();
  const allWellNavigationDetails = useAllWellNavigationDetails();
  const { dropNumber, inspection } = useSelectedDropImageParameters();
  const INTRESTINGSCOREID = 11;
  const selectedWellDetails = isDropWellCompareMode
    ? [allWellNavigationDetails[allWellNavigationDetails.length - 1]]
    : (allWellNavigationDetails as any);

  const selectedWellScores = useScoresForWells(
    selectedWellDetails?.map((w) => ({
      wellNumber: w?.wellNum,
      plateId: w?.plateID,
      dropNumber: dropNumber,
    })),
  );

  const imageBatchId = inspection?.groupedInspections?.find(
    (grp) => grp.plateId === selectedWellDetails?.[0]?.plateID,
  )?.imageBatchId;

  return useMemo(
    () =>
      selectedWellScores?.some((scores) =>
        scores.some(
          (score) =>
            score?.wellDropScoreGroupId === INTRESTINGSCOREID &&
            score?.dropNumber === dropNumber &&
            score?.scoreBatchId === imageBatchId,
        ),
      ),
    [selectedWellScores, selectedWellDetails],
  );
};

export function useNavigateToNextUnScoredWell(allPlates) {
  const dispatch = useDispatch();
  const allScoredWells = useAllScoredWells();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const { dropNumber, inspection } = useSelectedDropImageParameters();
  const navigateToNextUnscoredWell = useCallback(() => {
    const imageBatchId = inspection?.groupedInspections?.find(
      (grp) => grp.plateId === wellNavigationDetails?.plateID,
    )?.imageBatchId;
    let nextWell = getWellNavigationDetails(
      allPlates,
      wellNavigationDetails,
      1,
      TraversalDirection.Row,
      [],
    );

    while (
      nextWell &&
      allScoredWells.some(
        (scored) =>
          scored.plateId === nextWell.plateID &&
          scored.wellNumber === nextWell.wellNum &&
          scored.dropNumber === dropNumber &&
          scored.imageBatchId === imageBatchId,
      ) &&
      !(
        nextWell.plateID === wellNavigationDetails.plateID &&
        nextWell.wellNum === wellNavigationDetails.wellNum
      )
    ) {
      nextWell = getWellNavigationDetails(
        allPlates,
        nextWell,
        1,
        TraversalDirection.Row,
        [],
      );
    }

    if (nextWell) {
      dispatch(setWellNavigationDetails([nextWell]));
    }
  }, [allPlates, allScoredWells, wellNavigationDetails, dropNumber, inspection]);

  return { navigateToNextUnscoredWell };
}

export const useExperimentKeyboardHandler = (
  navigatorMap: NavigatorMapDTO,
  saveExperiment: (e) => void,
  zoomInvocker: (zoomIn: any) => void,
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>,
  isImagedExperiment: boolean,
  isCanvasInFocus: boolean,
) => {
  const isZoomLocked = useIsZoomLocked();
  const { changeInspection } = useInspectionNavigationHandler(navigatorMap);
  const { changeDrop } = useDropNavigationHandler();
  const { changeImagingSettings } = useImagingSettingsNavigationHandler(navigatorMap);
  const { changeRegions } = useRegionNavigationHandler();
  const { changePlate } = usePlateNavigationHandler();
  const { changeFocusLevel } = useFocusLevelNavigationHandler();
  const allPlates = useAllPlates();
  const dispatch = useRMDispatch();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const isRmLiteUser = useRMLite();
  const isPlateGenerated = usePlateGenerated();
  const productEdition = useProductEdition();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const updateCompositeImages = useUpdateCompositeImagesHandler();
  const { navigateToNextUnscoredWell } = useNavigateToNextUnScoredWell(allPlates);
  const isInfoMode = /\/info/.test(window.location.pathname);
  const isScreenRoute = window.location.pathname.includes('/screen');

  const handleUserKeyPress = useCallback(
    async (e) => {
      if (!isCanvasInFocus) {
        return;
      }
      const { key } = e;
      const displayMode = GetDisplayMode();
      const isDropMode = isDropModeUrl();
      const ctrlKey = e.ctrlKey || e.metaKey;
      const altKey = e.altKey;
      const shiftKey = e.shiftKey;

      if (ctrlKey && key === KeyboardKeys.S) {
        e.preventDefault();
        saveExperiment(e);
      }
      if (isInfoMode) {
        return;
      } else if (ctrlKey && key === KeyboardKeys.Plus) {
        e.preventDefault();
        if (!isZoomLocked || !isDropMode) {
          zoomInvocker(1);
        }
      } else if (ctrlKey && key === KeyboardKeys.Minus) {
        e.preventDefault();
        if (!isZoomLocked || !isDropMode) {
          zoomInvocker(-1);
        }
      } else if (ctrlKey && key === KeyboardKeys.Zero) {
        e.preventDefault();
        if (!isZoomLocked || !isDropMode) {
          zoomInvocker(0);
        }
      } else if (
        (displayMode === DisplayModes.IMAGE ||
          displayMode === DisplayModes.SCORE ||
          displayMode === DisplayModes.WELLIMAGE) &&
        ctrlKey &&
        (key === KeyboardKeys.ArrowRight || key === KeyboardKeys.ArrowLeft)
      ) {
        e.preventDefault();
        changeInspection(key === KeyboardKeys.ArrowRight ? 'next' : 'previous');
      } else if (
        (displayMode === DisplayModes.IMAGE ||
          displayMode === DisplayModes.SCORE ||
          displayMode === DisplayModes.WELLIMAGE) &&
        (key === KeyboardKeys.PageUp || key === KeyboardKeys.PageDown)
      ) {
        e.preventDefault();
        changeDrop(key === KeyboardKeys.PageUp ? 'next' : 'previous');
      } else if (
        (displayMode === DisplayModes.IMAGE ||
          displayMode === DisplayModes.SCORE ||
          displayMode === DisplayModes.WELLIMAGE) &&
        altKey &&
        (key === KeyboardKeys.ArrowRight || key === KeyboardKeys.ArrowLeft)
      ) {
        e.preventDefault();
        changeImagingSettings(key === KeyboardKeys.ArrowRight ? 'next' : 'previous');
      } else if (
        (displayMode === DisplayModes.IMAGE ||
          displayMode === DisplayModes.SCORE ||
          displayMode === DisplayModes.WELLIMAGE) &&
        shiftKey &&
        (key === KeyboardKeys.ArrowRight || key === KeyboardKeys.ArrowLeft)
      ) {
        e.preventDefault();
        changeRegions(key === KeyboardKeys.ArrowRight ? 'next' : 'previous');
      } else if (ctrlKey && e.shiftKey && key === KeyboardKeys.Space) {
        e.preventDefault();
        changePlate('previous');
      } else if (ctrlKey && key === KeyboardKeys.Space) {
        e.preventDefault();
        changePlate('next');
      } else if (ctrlKey && key === KeyboardKeys.Home) {
        e.preventDefault();
        dispatch(
          setWellNavigationDetails([
            {
              ...wellNavigationDetails,
              wellNum: 1,
              plateNum: 1,
              plateID: allPlates[0].plateId,
            },
          ]),
        );
      } else if (key === KeyboardKeys.Home) {
        e.preventDefault();
        dispatch(setWellNavigationDetails([{ ...wellNavigationDetails, wellNum: 1 }]));
      } else if (ctrlKey && key === KeyboardKeys.End) {
        e.preventDefault();
        const lastPlate = allPlates?.at(-1);
        dispatch(
          setWellNavigationDetails([
            {
              ...wellNavigationDetails,
              wellNum: lastPlate.cols * lastPlate.rows,
              plateNum: lastPlate?.plateNumber,
              plateID: lastPlate?.plateId,
            },
          ]),
        );
      } else if (key === KeyboardKeys.End) {
        e.preventDefault();
        const plate = allPlates[0];
        dispatch(
          setWellNavigationDetails([
            { ...wellNavigationDetails, wellNum: plate.cols * plate.rows },
          ]),
        );
      } else if (key === KeyboardKeys.F4) {
        e.preventDefault();
        const experimentCanvasRoutes = isScreenRoute
          ? ScreenExperimentCanvasRoutes
          : getExperimentCanvasRoutes(
              isPlateGenerated,
              isImagedExperiment,
              isRmLiteUser,
              productEdition,
            );
        const currentIndex = experimentCanvasRoutes.indexOf(
          GetDisplayMode() as DisplayMode,
        );
        const newIndex = (currentIndex + 1) % experimentCanvasRoutes.length;
        SetDisplayMode(experimentCanvasRoutes[newIndex]);
        setRefresh(true);
      } else if (
        displayMode === DisplayModes.WELLIMAGE &&
        ((ctrlKey && (key === KeyboardKeys.ArrowUp || key === KeyboardKeys.ArrowDown)) ||
          key === KeyboardKeys.F11 ||
          key === KeyboardKeys.F12)
      ) {
        e.preventDefault();
        if (key === KeyboardKeys.ArrowUp || key === KeyboardKeys.F11) {
          changeFocusLevel('next');
        } else {
          changeFocusLevel('previous');
        }
      } else if (!ctrlKey && !shiftKey && key === KeyboardKeys.Space) {
        if (!isScoringFeatureEnabled(productEdition)) {
          return;
        }
        navigateToNextUnscoredWell();
      } else if (key === KeyboardKeys.F5) {
        e.preventDefault();
        updateCompositeImages(wellNavigationDetails, selectedDropImageParameters, true);
      }
    },

    [
      isZoomLocked,
      saveExperiment,
      zoomInvocker,
      changeInspection,
      changeDrop,
      changeImagingSettings,
      changeRegions,
      changePlate,
      dispatch,
      wellNavigationDetails,
      selectedDropImageParameters,
      allPlates,
      setRefresh,
      changeFocusLevel,
      isPlateGenerated,
      isRmLiteUser,
      productEdition,
    ],
  );

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    window.addEventListener('keydown', handleUserKeyPress, { signal });
    return () => {
      abortController.abort();
    };
  }, [handleUserKeyPress]);
};

export const usePlateSize = () => {
  const exp = useRMSelector((state) => state.experiment.expData);
  const { width: windowInnerWidth, height: windowInnerHeight } = useWindowSize();
  return useMemo(() => {
    let plateWidth = 0;
    let plateHeight = 0;
    if (exp) {
      const availableWidthPerPlate =
        GetExperimentCanvasWidth(WIDTH_MAIN_DIV, windowInnerWidth) / exp.colCount;
      const availableHeightPerPlate =
        GetExperimentCanvasHeight(windowInnerHeight) / exp.rowCount;

      const paddedPlateWidth = availableWidthPerPlate - GetDefaultPlatePadding();
      const paddedPlateHeight = availableHeightPerPlate - GetDefaultPlatePadding();

      if (exp.colCount > exp.rowCount) {
        plateWidth = paddedPlateWidth;
        plateHeight = (paddedPlateWidth * exp.containerRows) / exp.containerCols;

        if (plateHeight > paddedPlateHeight) {
          plateHeight = paddedPlateHeight;
          plateWidth = (paddedPlateHeight / exp.containerRows) * exp.containerCols;
        }
      } else {
        plateHeight = paddedPlateHeight;
        plateWidth = (paddedPlateHeight / exp.containerRows) * exp.containerCols;

        if (plateWidth > paddedPlateWidth) {
          plateWidth = paddedPlateWidth;
          plateHeight = (paddedPlateWidth * exp.containerRows) / exp.containerCols;
        }
      }

      const wellRectWidth = plateWidth / exp.containerCols;

      plateWidth -= wellRectWidth;
      plateHeight -= wellRectWidth;
    }

    return { plateWidth, plateHeight };
  }, [windowInnerWidth, windowInnerHeight]);
};

export const usePlatesImagesStructureData = () => {
  const exp = useRMSelector((state) => state.experiment);
  const dispatch = useRMDispatch();
  const { plateWidth, plateHeight } = usePlateSize();

  const plateImagesStructure = useMemo(() => {
    if (!exp.expData) {
      return [];
    }

    const { plateDto = [] } = exp.expData;
    const { plateImageStructure = [] } = exp;

    return plateDto.map((plate) => {
      const startX =
        plateWidth * (plate.colPos - 1) + (GetPlatePadding() / 2) * plate.colPos;
      const startY =
        plateHeight * (plate.rowPos - 1) + (GetPlatePadding() / 2) * plate.rowPos;

      const matchingImageStructure = plateImageStructure.find(
        (img) => img.plateId === plate.plateId,
      );

      return {
        plateId: plate.plateId,
        plateNumber: plate.plateNumber,
        startX,
        startY,
        width: plateWidth,
        height: plateHeight,
        imageCompositeKeyString: matchingImageStructure?.imageCompositeKeyString ?? null,
      };
    });
  }, [exp, plateWidth, plateHeight]);

  useEffect(() => {
    if (!plateImagesStructure.length) {
      return;
    }

    const plateSize = exp?.plateImageStructure?.some((p) => p.width === plateWidth);

    if (!plateSize) {
      dispatch(setPlateImagesStructure(plateImagesStructure));
    }
  }, [plateWidth, plateHeight]);

  return plateImagesStructure;
};

export const useImagedWells = (navigatorMap: NavigatorMapDTO): PlateWellDTO[] => {
  const expData = useRMSelector((state) => state.experiment.expData);
  const selectedDropImageParameters = useSelectedDropImageParameters();

  const cpIds = useMemo(() => {
    return expData?.profiles?.map((p) => p.id) ?? [];
  }, [expData?.profiles]);

  const plateIds = useMemo(() => {
    return expData?.plateDto?.map((p) => p.plateId);
  }, [expData?.plateDto]);

  const inspectionIds = useMemo(
    () =>
      selectedDropImageParameters?.inspection?.groupedInspections
        ?.filter((i) => plateIds?.includes(i.plateId))
        .map((i) => i.imageBatchId) ?? [],
    [selectedDropImageParameters],
  );
  return useMemo(() => {
    if (!navigatorMap) {
      return [];
    }
    return getImagedWellsFromNavigatorMap(
      navigatorMap,
      selectedDropImageParameters?.dropNumber,
      selectedDropImageParameters?.regionName,
      cpIds,
      inspectionIds,
    );
  }, [navigatorMap, selectedDropImageParameters, cpIds, inspectionIds]);
};
type QueueItem = {
  oldScores: ScoresOfWellDrops[][];
  newScores: ScoringWell[];
  nextWell: WellNavigationDetails | null;
};

export function useScoreExperimentWells(delay = 500) {
  const dispatch = useDispatch();
  const store = useSelector((s: RootState) => s);
  const restartScoringOnceDone = useSystemProperty(
    PropertyConstants.RestartScoringOnceDone,
    true,
  );
  const { showModal, hideModal } = useModalHandlers();

  // Immediate handler: apply optimistic UI updates using precomputed filtered array
  const handleImmediate = useCallback(
    (item: QueueItem) => {
      // item.filtered is already computed by caller
      dispatch(appendScoreExperimentWellsInProgressCount(item.newScores.length));
      dispatch(setScoringWell(item.newScores));

      if (item.nextWell !== null) {
        // take last navigation detail and replace wellNum with next
        const navDetails =
          store.experiment?.wellSelectionDetails?.wellNavigationDetails ?? [];
        const last = navDetails[navDetails.length - 1];
        if (
          !restartScoringOnceDone &&
          item.nextWell.wellNum < last.wellNum &&
          item.nextWell.plateID <= last.plateID
        ) {
          showModal({
            heading: 'ROCK MAKER',
            body: 'You have reached the end of experiment',
            isOkOnly: true,
            onOk: hideModal,
          });
        }
        if (last) {
          dispatch(
            setWellNavigationDetails([
              {
                ...last,
                ...item.nextWell,
              } as WellNavigationDetails,
            ]),
          );
        }
      }
    },
    [dispatch, store],
  );

  // Debounced batch: merge queued filtered arrays and call the API
  const handleBatch = useCallback(async (items: QueueItem[]) => {
    const newScores: ScoringWell[] = items.flatMap((it) => it.newScores);

    if (newScores.length === 0) {
      return;
    }

    try {
      await plateService.setDropScores(newScores);
    } catch {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Failed to assign score to well(s), please try again.',
      );

      const oldScores = items.flatMap((it) => it.oldScores);
      const reversedScores = newScores.map((s, index) => {
        const oldScore = oldScores?.[index]
          ?.flat()
          ?.find(
            (sw) =>
              sw.wellDropScoreGroupId === s.wellDropScoreGroupId &&
              sw.scoreBatchId === s.imageBatchId,
          );
        return {
          ...s,
          wellDropScoreId: oldScore?.wellDropScoreId || s.wellDropScoreId,
          isDeleteScore: oldScore
            ? oldScore.wellDropScoreId === s.wellDropScoreId
              ? !s.isDeleteScore
              : s.isDeleteScore
            : true,
        };
      });

      dispatch(setScoringWell(reversedScores));
    } finally {
      dispatch(
        appendScoreExperimentWellsInProgressCount(
          items.reduce((acc, item) => acc - item.newScores.length, 0),
        ),
      );
    }
  }, []);

  const { add, flush } = useDebouncedQueue<QueueItem>(
    handleImmediate,
    handleBatch,
    delay,
  );

  const score = useCallback(
    (params: {
      wellDropScoreId: number;
      wellDropScoreGroupId: number;
      disAllowScoreRemove?: boolean;
      autoSelectNextWell: boolean;
      nextWellDetails?: WellNavigationDetails;
      forceRemoveInteresting?: boolean;
    }) => {
      const {
        wellDropScoreId,
        wellDropScoreGroupId,
        disAllowScoreRemove,
        autoSelectNextWell,
        nextWellDetails,
        forceRemoveInteresting,
      } = params;

      const experiment = store.experiment;
      if (!experiment) {
        return;
      }

      const { wellSelectionDetails, expData } = experiment || {};
      const selectedWellDetails = wellSelectionDetails?.wellNavigationDetails;
      const selectedDropImageParameters =
        wellSelectionDetails?.selectedDropImageParameters;
      const { inspection, dropNumber } = selectedDropImageParameters;

      const wellLabels = GetWellsLabels();

      const plates = expData?.plateDto;

      const selectedWellScores = getScoresOfWells(
        selectedWellDetails.map((wd) => ({
          wellNumber: wd.wellNum,
          plateId: wd.plateID,
          dropNumber,
          imageBatchId: inspection.groupedInspections?.find(
            (g) => g.plateId === wd.plateID,
          )?.imageBatchId,
        })),
        plates,
      );

      // compute nextWell optimistically
      let nextWell: WellNavigationDetails | null = null;
      if (autoSelectNextWell && nextWellDetails) {
        nextWell = nextWellDetails;
      } else if (autoSelectNextWell) {
        const index = wellLabels.findIndex(
          (num) => num.id === selectedWellDetails[selectedWellDetails.length - 1].wellNum,
        );
        nextWell = {
          ...selectedWellDetails[selectedWellDetails.length - 1],
          wellNum: wellLabels[(index + 1) % wellLabels.length].id,
        };
      }

      const scores = buildScoringWells({
        wellDropScoreId,
        wellDropScoreGroupId,
        wells: selectedWellDetails.map((selectedWell) => ({
          wellNumber: selectedWell.wellNum,
          plateId: selectedWell.plateID,
          imageBatchId: inspection.groupedInspections?.find(
            (g) => g.plateId === selectedWell.plateID,
          )?.imageBatchId,
          dropNumber,
        })),
        selectedWellScores,
        forceRemoveInteresting,
      });

      const scoringAction = resolveScoringAction({ scores, disAllowScoreRemove });

      if (scoringAction.blocked) {
        showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, scoringAction.message);
      }

      add({
        oldScores: selectedWellScores,
        newScores: scoringAction.scores,
        nextWell,
      });
      if (
        selectedWellDetails[selectedWellDetails.length - 1].wellNum ===
          wellLabels.length ||
        selectedWellDetails.length > 1
      ) {
        flush();
      }
    },
    [store, add],
  );

  return score;
}
